import {AxiosError} from 'axios'
import {ApiCrm, ApiProgram} from '../../../../../api/api'
import {DonationAffiliateSingleResultInterface} from '../interfaces/program-affiliate-single-resultInterface'
import {
  DonationAffiliateResultInterface,
  DonationAffiliateData,
} from '../interfaces/program-affiliate-resultInterface'
import {GeneralInterface} from '../../../../../interfaces/general.interface'

export interface GetAllDonationAffiliateParam {
  page?: number
  size?: number
  reference?: string
  program_id?: string
}

export const GetAllDonationAffiliate = async (
  params: GetAllDonationAffiliateParam
): Promise<DonationAffiliateResultInterface> => {
  try {
    let response = await ApiProgram.get('donations-by-affiliate-code', {params: params})
    return response.data
  } catch (e) {
    let a = e as AxiosError
    let response: DonationAffiliateResultInterface = a.response?.data
    return response
  }
}

export const ShowDonationAffiliate = async (
  id: string
): Promise<DonationAffiliateSingleResultInterface> => {
  try {
    let response = await ApiProgram.get('/public/donations/' + id)
    return response.data as DonationAffiliateSingleResultInterface
  } catch (e) {
    let a = e as AxiosError
    let response: DonationAffiliateSingleResultInterface = a.response?.data
    return response
  }
}

export const SubmitDonationAffiliate = async (
  form: DonationAffiliateData
): Promise<DonationAffiliateSingleResultInterface> => {
  try {
    let response = await ApiProgram.post('/donation', form)
    return response.data as DonationAffiliateSingleResultInterface
  } catch (e) {
    let a = e as AxiosError
    let response: DonationAffiliateSingleResultInterface = a.response?.data
    return response
  }
}

export const UpdateDonationAffiliate = async (
  id: string,
  form: DonationAffiliateData
): Promise<DonationAffiliateSingleResultInterface> => {
  try {
    let response = await ApiProgram.post('/donation/' + id, form)
    return response.data as DonationAffiliateSingleResultInterface
  } catch (e) {
    let a = e as AxiosError
    let response: DonationAffiliateSingleResultInterface = a.response?.data
    return response
  }
}

export const DeleteDonationAffiliate = async (id: string): Promise<GeneralInterface> => {
  try {
    let response = await ApiProgram.delete('/donation/' + id)
    return response.data as GeneralInterface
  } catch (e) {
    let a = e as AxiosError
    let response: GeneralInterface = a.response?.data
    return response
  }
}

export const GetTotalDonationAffiliate = async (): Promise<GeneralInterface> => {
  try {
    let response = await ApiProgram.get('total-donations-affiliate')
    return response.data as GeneralInterface
  } catch (e) {
    let a = e as AxiosError
    let response: GeneralInterface = a.response?.data
    return response
  }
}

export const GetTotalDonationAffiliateByTunai = async (id: string): Promise<GeneralInterface> => {
  try {
    let response = await ApiProgram.get('/total-donation-affiliator-tunai/' + id)
    return response.data as GeneralInterface
  } catch (e) {
    let a = e as AxiosError
    let response: GeneralInterface = a.response?.data
    return response
  }
}
export const GetTotalDonationAffiliateByTransfer = async (
  id: string
): Promise<GeneralInterface> => {
  try {
    let response = await ApiProgram.get('/total-donation-affiliator-transfer/' + id)
    return response.data as GeneralInterface
  } catch (e) {
    let a = e as AxiosError
    let response: GeneralInterface = a.response?.data
    return response
  }
}

export const GetTotalCustomer = async (): Promise<GeneralInterface> => {
  try {
    let response = await ApiCrm.get('total-customers-affiliate')
    return response.data as GeneralInterface
  } catch (e) {
    let a = e as AxiosError
    let response: GeneralInterface = a.response?.data
    return response
  }
}
